<div class="app-layout">
  <!-- Mobile backdrop -->
  <div class="sidebar-backdrop"
       [class.active]="!sidebarHidden"
       (click)="toggleSidebar()">
  </div>

  <aside class="sidebar-pane" [class.hidden]="sidebarHidden">
    <app-side-bar></app-side-bar>
  </aside>

  <div class="app-body">
    <app-header (menuToggle)="toggleSidebar()"></app-header>
    <main class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
